export const APP_STORE_URLS = Object.freeze({
	ANDROID: 'https://play.google.com/store/apps/details?id=com.tigsipay.app',
	IOS: 'https://apps.apple.com/app/tigsipay/id6751570216',
});
